import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { getPushStatus, initPushNotifications } from '../capacitor/pushNotifications';

// Diagnostics for push registration, shown in the edit profile modal.
//
// Temporary, and here for one reason: a failure between granting the
// notification prompt and the token reaching users.push_token is completely
// silent. Capacitor strips console output from release builds, so nothing on a
// TestFlight device can be read from the Mac, and the 1.2.1 build registered
// zero tokens across 78 accounts with no way to see where it stopped.
//
// Remove this section, and the loggingBehavior override in capacitor.config.ts,
// once push has produced a token on a real device.

const STEPS = [
  { key: 'listenersAttached', label: 'Listeners attached' },
  { key: 'registerCalled', label: 'Asked iOS for a token' },
  { key: 'tokenReceived', label: 'Token received' },
  { key: 'tokenSaved', label: 'Token saved to your account' },
];

const PushStatusSection = () => {
  const [status, setStatus] = useState(getPushStatus);
  const [retrying, setRetrying] = useState(false);

  // The run that matters happens at sign in, long before this modal opens, so
  // poll rather than reading once: a retry started here finishes seconds later.
  useEffect(() => {
    const id = setInterval(() => setStatus(getPushStatus()), 1000);
    return () => clearInterval(id);
  }, []);

  const retry = async () => {
    setRetrying(true);
    await initPushNotifications({ force: true });
    setStatus(getPushStatus());
    setRetrying(false);
  };

  const native = Capacitor.isNativePlatform();

  return (
    <div style={{ marginTop: 18, paddingTop: 14, borderTop: '1px solid var(--color-border)' }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-text-muted)', marginBottom: 8 }}>
        Notifications
      </div>

      {!native ? (
        <div style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>
          Push notifications only run in the iPhone app.
        </div>
      ) : (
        <>
          <div style={{ fontSize: 12, color: 'var(--color-text-muted)', marginBottom: 8 }}>
            Permission: {status.permission || 'not checked yet'}
          </div>

          <div style={{ display: 'grid', gap: 4, marginBottom: 10 }}>
            {STEPS.map(({ key, label }) => (
              <div key={key} style={{ fontSize: 12, color: status[key] ? 'var(--color-success-deep)' : 'var(--color-text-muted)' }}>
                {status[key] ? '✓' : '·'} {label}
              </div>
            ))}
          </div>

          {status.lastError && (
            <div
              style={{
                fontSize: 12,
                color: 'var(--color-danger-text)',
                backgroundColor: 'var(--color-danger-bg)',
                border: '1px solid var(--color-danger-border)',
                borderRadius: 8,
                padding: '8px 10px',
                marginBottom: 10,
                wordBreak: 'break-word',
              }}
            >
              {status.lastError}
            </div>
          )}

          <button
            type="button"
            onClick={retry}
            disabled={retrying}
            style={{
              padding: '8px 12px',
              borderRadius: 8,
              border: '1.5px solid var(--color-border)',
              backgroundColor: 'var(--color-bg-card)',
              color: 'var(--color-text-muted)',
              fontWeight: 600,
              fontSize: 13,
              cursor: retrying ? 'not-allowed' : 'pointer',
            }}
          >
            {retrying ? 'Trying...' : 'Try again'}
          </button>
        </>
      )}
    </div>
  );
};

export default PushStatusSection;
